




































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { mapGetters, mapActions, mapState } from "vuex";
import uuidv1 from "uuid/v1";
import { TranslateResult } from "vue-i18n";
import CdkColorPicker from "@/components/CdkColorPicker/CdkColorPicker.vue";
import CdkFilterPassBadge from "@/components/CdkFilterPassBadge/CdkFilterPassBadge.vue";
import { filterRules } from "@/utils/filterRules";
import { isMobile } from "@/utils/responsive";
import CdkFilterForm from "./CdkFilterForm.vue";
import useAuthentication from "@/composition/useAuthentication";
import useMatomoEvent from "@/composition/useMatomoEvent";
import DpaNotificationsAdDialogue from "@/components/DpaNotificationsAd/DpaNotificationsAdDialogue.vue";

@Component({
  // @ts-ignore
  setup() {
    const { validateAndRetrieveToken, profile } = useAuthentication();
    return { token: validateAndRetrieveToken, profile, useMatomoEvent };
  },
  components: {
    DpaNotificationsAdDialogue,
    CdkFilterForm,
    CdkColorPicker,
    CdkFilterPassBadge,
  },
  computed: {
    ...mapGetters("filters", {
      filterNames: "getFilterNames"
    }),
    ...mapState("stageconfig", ["config"])
  },
  methods: {
    ...mapActions("filters", ["saveFilter", "updateFilter"])
  },
  inject: ["eventBus"]
})
export default class CdkFilterFormProvider extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  insideSettings!: boolean;

  filterNames;

  saveFilter;

  updateFilter;

  eventBus;

  internalName = "";

  internalColor = "";

  isEmailNotificationEnabled = false;

  isPushEnabled = false;

  showDpaIdAppAd: boolean = false;

  token: Function;

  profile: any;

  get emailNotifications() {
    return this.isEmailNotificationEnabled;
  }

  set emailNotifications(value) {
    this.isEmailNotificationEnabled = value;

    if (value) {
      // @ts-ignore
      // eslint-disable-next-line no-unused-expressions
      window.Appcues?.track("Saved Search Notification Enabled", {
        type: "email"
      });
    }
  }

  get pushNotifications() {
    return this.isPushEnabled;
  }

  set pushNotifications(value) {
    this.isPushEnabled = value;

    if (value) {
      // @ts-ignore
      // eslint-disable-next-line no-unused-expressions
      window.Appcues?.track("Saved Search Notification Enabled", {
        type: "push"
      });
    }
  }

  setInternalName(value) {
    this.internalName = value;
  }

  setInternalColor(value) {
    this.internalColor = value;
  }

  get internalValues() {
    return {
      color: this.internalColor,
      name: this.internalName
    };
  }

  get currentFilter() {
    return this.$store.getters["filters/getFilterById"](
      this.$route.query.filterId
    );
  }

  get initialName() {
    const newFilterName = this.currentFilter ? this.currentFilter.name : "";

    return newFilterName;
  }

  get initialColor() {
    return this.currentFilter ? this.currentFilter.color : "#e53935";
  }

  get newFilterNameNoConflict() {
    return (
      this.filterNames.filter(name => name === this.internalName).length === 0
    );
  }

  get isNewFilterNameValid() {
    return (
      this.internalName &&
      this.internalName.length > 0 &&
      this.newFilterNameNoConflict
    );
  }

  get isFilterFormValid() {
    return this.isNewFilterNameValid && this.internalColor.length > 0;
  }

  created() {
    this.internalName = this.initialName;
    this.internalColor = this.initialColor;
  }

  async saveUserFilter() {
    const newUserFilter = {
      id: uuidv1(),
      color: this.internalColor,
      name: this.internalName,
      owner: this.profile.sub,
      description: "",
      filterRules: filterRules(this),
      isVisible: true,
      isPublic: false,
      isNotificationEnabled: this.isEmailNotificationEnabled,
      isPushEnabled: this.isPushEnabled
    };
    this.$emit("close");
    this.eventBus.$emit("frc-close");
    this.eventBus.$emit("close-mobile-frc");
    await this.saveFilter({
      filter: newUserFilter,
      authJWT: this.token()
    });

    const { path, params, query } = this.$route;
    this.$router.push({
      path,
      params,
      query: {
        ...query,
        filterId: newUserFilter.id
      }
    });

    // @ts-ignore
    // eslint-disable-next-line no-unused-expressions
    window.Appcues?.track("Search Saved");
  }

  overwriteFilter() {
    this.updateFilter({
      filter: {
        ...this.currentFilter,
        filterRules: filterRules(this)
      },
      authJWT: this.token()
    });
    this.$emit("close");
    this.eventBus.$emit("frc-close");
    this.eventBus.$emit("close-mobile-frc");
  }

  get isNewFilter() {
    return !(this.insideSettings || this.currentFilter);
  }

  @Watch("$route")
  onRouteChanged() {
    this.internalName = this.initialName;
    this.internalColor = this.initialColor;
  }

  @Watch("internalValues")
  onInternalValuesChanged() {
    if (this.insideSettings && this.currentFilter) {
      if (
        this.currentFilter.name !== this.internalName ||
        this.currentFilter.color !== this.internalColor
      ) {
        this.updateFilter({
          filter: {
            ...this.currentFilter,
            ...this.internalValues,
            filterRules: filterRules(this)
          },
          authJWT: this.token()
        });
      }
    }
  }

  /**
   * Returns a compound string for the notification settings
   * @return {String}
   */
  get emailNotificationsLabel(): TranslateResult {
    return this.$t("byEmail");
  }

  get pushNotificationsLabel(): TranslateResult {
    return this.$t("getNotifications");
  }

  get mobileSearch() {
    return isMobile(this);
  }
}
